export const baseUrl = "https://api.avastyle.ir";
